import { Lock, Sparkle } from "@phosphor-icons/react";
import { SEASONS } from "@/data/categories";
import { Eyebrow } from "@/components/landing/shared";

const TINT = {
  Childhood: ["#FFF4F0", "#F7C4B8", "#E06D53"],
  "Teenage years": ["#F7F4FA", "#DDD5E8", "#8C6CB0"],
  "Young adult": ["#F2F7F4", "#C6DCD0", "#4A8B6E"],
  Midlife: ["#FAF5EE", "#EBD9BF", "#D9A036"],
  Retirement: ["#F0F7F9", "#C3E3E9", "#36858B"],
  Seniors: ["#FAF0F3", "#ECC3CF", "#C85B7A"],
  Other: ["#FAF6ED", "#EDE0C8", "#C78828"],
};

export const SeasonsShowcase = () => (
  <section data-testid="landing-seasons" className="mx-auto max-w-6xl px-5 py-20 sm:px-6">
    <Eyebrow color="#36858B">Life Seasons</Eyebrow>
    <h2 className="mt-3 font-serif text-3xl text-[#2D2824] sm:text-4xl">Seven seasons, one beautiful story</h2>
    <p className="mt-3 max-w-2xl text-[#6E665E]">Every memory finds its place in a season of your life, kept like the pages of a personal notebook.</p>
    <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-4">
      {SEASONS.map((s, i) => {
        const [bg, border, tag] = TINT[s.id] || TINT.Other;
        const free = s.free;
        return (
          <div
            key={s.id}
            data-testid={`landing-season-${s.id.replace(/\s+/g, "-").toLowerCase()}`}
            className={`landing-rise relative rounded-2xl border-2 p-4 sm:p-5 transition-transform hover:-translate-y-1 ${free ? "col-span-2 md:p-6" : ""}`}
            style={{ background: bg, borderColor: border, animationDelay: `${i * 60}ms` }}
          >
            <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-1 text-[10px] font-semibold text-white sm:px-2.5 sm:text-[11px]" style={{ background: tag }}>
              {free ? <><Sparkle size={11} weight="fill" /> Free 10-day trial</> : <><Lock size={11} weight="fill" /> Lifetime Access</>}
            </span>
            <h3 className={`mt-4 font-serif text-[#2D2824] ${free ? "text-3xl" : "text-xl"}`}>{s.label}</h3>
            <p className="mt-1 text-sm text-[#6E665E]">{s.note}</p>
            {free && (
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#6E665E]">
                Your starting point — school days, family traditions, first friends and the places that shaped you.
              </p>
            )}
          </div>
        );
      })}
    </div>
  </section>
);
